import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';
import { PageTraining, PageTrainings } from '../pages/training';




const RouteTrainings = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageTrainings/>
      </Route>
      <Route path={`${path}/:_id`}>
        <PageTraining />
      </Route>
    </Switch>
  );
};

export default RouteTrainings;
